import { forwardRef, type ComponentProps, type Ref } from 'react';
import styled from 'styled-components';
import Label from '@ovpn/ui/label';

import { boxed } from '@sso/shared/hocs';

import Radio from './Radio';
import Box from './Box';

type RadioGroupProps = Omit<ComponentProps<typeof Radio>, 'checked'> & {
    options: { id: string; title: string }[];
    value?: string;
};

const Container = styled(Box)`
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    row-gap: 16px;
`;

function RadioGroup(
    {
        description,
        appearance,
        className,
        layout,
        title,
        dir,

        options,
        value,

        ...inputProps
    }: RadioGroupProps,
    ref: Ref<HTMLInputElement>,
) {
    return (
        <Label
            required={inputProps.required}
            description={description}
            appearance={appearance}
            className={className}
            layout={layout}
            title={title}
            dir={dir}
            as="div"
        >
            <Container mt={title ? 12 : 0}>
                {options.map(({ id, title }) => (
                    <Radio
                        {...inputProps}
                        id={`${id}-radio-input`}
                        checked={id === value}
                        title={title}
                        type="radio"
                        value={id}
                        ref={ref}
                        key={id}
                    />
                ))}
            </Container>
        </Label>
    );
}

export default boxed(forwardRef(RadioGroup));
